import React, { Component } from 'react';
import Bordereau from '../bordereau';

class BCnam extends Component {
  render() {
    return (
      <Bordereau
        type="cnam"
        active={10}
        changeActiveItemSideBar={this.props.changeActiveItemSideBar}
        changeNamePage={this.props.changeNamePage}
        changeActiveItemSideBarCompta={this.props.changeActiveItemSideBarCompta}
      />
    );
  }
}

export default BCnam;
